





























































import { Component, Emit, Prop, Provide, Vue, Watch } from 'vue-property-decorator'
import { cwBookSeries, getCwBooks, recordBook, getInitInfo } from './../model/api'
import { Book } from './../model/book_model'
@Component
export default class SelectBook extends Vue {
  public holder = '请选择教材、书册'
  public visible = false
  public disabled = true
  public activeKey = '1'
  public finish2 = false
  public gradeList = []
  public showName = ''
  public book: Book = {
    ancestors: [],
    created_at: '',
    has_child: false,
    name: '',
    node_level: '',
    node_type: '',
    parent_id: '',
    rank: '',
    subject_id: '',
    updated_at: '',
    id: ''
  }
  public temp: Book = {
    ancestors: [],
    created_at: '',
    has_child: false,
    name: '',
    node_level: '',
    node_type: '',
    parent_id: '',
    rank: '',
    subject_id: '',
    updated_at: '',
    id: ''
  }
  public defaultBook: any = []
  public grade: any = {}
  public grades = []
  public books: Book[] = []
  @Prop({
    default() {
      return '1'
    }
  })
  public reset!: string | number | boolean

  public get subjectId() {
    return this.$store.state.subject.value
  }
  public get subject() {
    return this.$store.state.subject
  }
  @Watch('activeKey')
  public onKeyChange(val) {
    if (~~val === 2 && this.gradeList && this.gradeList.length === 0 && this.book && this.book.id) {
      this.getBooks()
    }
  }
  @Watch('subjectId')
  public onSubjectChange(val) {
    this.resetMethod()
    this.getInitInfo()
    this.getBookSeries()
  }
  @Watch('reset')
  public onResetChange(val) {
    if (val === '2') {
      // this.resetMethod()
    }
  }
  @Watch('visible')
  public onVisibleChange(val) {
    if (!val) {
      this.activeKey = '1'
      if (this.finish2) {
        this.onComplete({
          series_id: this.book.id,
          grade: this.grade.id,
          bookName: this.book.name,
          gradeName: this.grade.name
        })
      } else if (!this.finish2) {
        if (this.subjectId === this.temp.subject_id) {
          this.book = this.temp
        } else {
          this.temp = {
            ancestors: [],
            created_at: '',
            has_child: false,
            name: '',
            node_level: '',
            node_type: '',
            parent_id: '',
            rank: '',
            subject_id: '',
            updated_at: '',
            id: ''
          }
        }
      }
    }
  }
  @Watch('book', { deep: true })
  public onBookChange(val, old) {
    if (val && val.id) {
      this.disabled = false
    }
    if (old && old.id) {
      this.temp = JSON.parse(JSON.stringify(old))
    }
  }
  @Emit()
  public onComplete(val) {
    return val
  }
  /**
   * mounted
   */
  public mounted() {
    this.getBookSeries()
    this.getInitInfo()
  }
  // 获取基本信息
  public async getInitInfo() {
    const res = await getInitInfo({
      subject_id: this.subjectId,
      data_type: 'cw'
    })
    this.defaultBook = res.data.default_book
    this.handleDefault()
  }
  public handleDefault() {
    if (this.defaultBook && this.defaultBook.length > 0) {
      this.book = this.defaultBook[0]
      this.grade = this.defaultBook[1]
      this.onComplete({
        series_id: this.book.id,
        grade: this.grade.id,
        bookName: this.book.name,
        gradeName: this.grade.name
      })
      if (this.subjectId === this.book.subject_id) {
        this.temp = JSON.parse(JSON.stringify(this.book))
      }
    }
  }
  public resetMethod() {
    this.book = {
      ancestors: [],
      created_at: '',
      has_child: false,
      name: '',
      node_level: '',
      node_type: '',
      parent_id: '',
      rank: '',
      subject_id: '',
      updated_at: '',
      id: ''
    }
    this.grade = {
      name: '',
      val: 0
    }
    this.temp = {
      ancestors: [],
      created_at: '',
      has_child: false,
      name: '',
      node_level: '',
      node_type: '',
      parent_id: '',
      rank: '',
      subject_id: '',
      updated_at: '',
      id: ''
    }
  }
  /**
   * getBookSeries
   */
  public async getBookSeries() {
    let { data } = await cwBookSeries({ subject_id: this.subjectId })
    this.books = data
    // 清空
    this.gradeList = []
  }
  /**
   * getBooks
   */
  public async getBooks() {
    let { data, success }: any = await getCwBooks({ series_id: this.book.id })
    if (success) {
      this.gradeList = data
    }
  }
  /**
   * chooseBook
   */
  public chooseBook(item: Book) {
    if (item && item.id) {
      this.book = item
      // this.temp = item
      this.getBooks()
      this.finish2 = false
      this.activeKey = '2'
    }
  }
  /**
   * chooseGrade
   */
  public chooseGrade(item: any) {
    if (item && item.id) {
      this.grade = item
      this.finish2 = true
      this.visible = false
      if (this.grade && this.grade.id) {
        this.record()
        this.temp = JSON.parse(JSON.stringify(this.grade))
      }
    }
  }
  // record
  public async record() {
    let data = await recordBook({
      series_id: this.book.id,
      book_id: this.grade.id,
      subject_id: this.subjectId,
      data_type: 'cw',
    })
  }
}
